import { MONTHS } from './constants';
import { COMPANY_STATUS } from '../constants';
import { CompanyListItemType } from '../table/types';

export const getAvailableMonths = (afterMonth: any) => MONTHS.filter((m) => !afterMonth || m.value > afterMonth);

export const mapRequest = (company: CompanyListItemType) => {
  const cleanCompany = { ...company } as { [key: string]: any };
  delete cleanCompany.logo_url;

  if (cleanCompany.status === COMPANY_STATUS.IN_TRIAL) {
    const payload = { ...cleanCompany };
    const { mystery_shop_setting } = cleanCompany;

    payload.mystery_shop_setting = {
      shop_priority: mystery_shop_setting.shop_priority,
    };

    return payload;
  } else if (cleanCompany.status === COMPANY_STATUS.DEMO) {
    const payload = {
      name: cleanCompany.name,
      primary_user_id: cleanCompany.primary_user_id,
      p_c_name: cleanCompany.p_c_name,
      p_c_phone: cleanCompany.p_c_name,
      status: cleanCompany.status,
    };

    return payload;
  }

  return cleanCompany;
};
